import { AbstractControl, UntypedFormGroup } from "@angular/forms";
import { Jurisdiction, MultiDepositLimit } from "@obg/ngx.core";

export type MultiDepositLimitFormGroup = FormGroupType<MultiDepositLimit, keyof MultiDepositLimit>;

export interface FormGroupType<FormType, PropsType extends keyof FormType> extends UntypedFormGroup {
	controls: Record<keyof Pick<FormType, PropsType>, AbstractControl>;
}

export interface MultiDepositLimitFormSuggestions {
	monthlyDepositLimit?: string | undefined;
	weeklyDepositLimit?: string | undefined;
	dailyDepositLimit?: string | undefined;
}

export interface JurisdictionAndDepositLimitsResponse {
	jurisdiction: Jurisdiction | undefined;
	currentWeeklyLimit: number | undefined;
	hasCurrentLimits: boolean;
}

export interface MultiDepositLimitDialogData {
	newDepositLimits?: MultiDepositLimit;
	displayInfoText?: boolean;
	isPostLogin?: boolean;
}

export enum MultiSessionLimitPeriod {
	Daily = 1,
	Weekly = 7,
	Monthly = 30,
}
